import React, { Component } from 'react';
import { Alert } from 'reactstrap';

class PermissionWrapper extends Component {

    render() {
        const permissionGranted = (!("allowedPermission" in this.props)) ||
            this.props.allowedPermission === '' || this.props.allowedPermission == null || 
            this.props.userPermissions.findIndex(i => i.toUpperCase() === this.props.allowedPermission.toUpperCase()) > -1;
        return (<>
            {(permissionGranted) ?
                <>
                    {this.props.children}
                </>
                :
                (("hidden" in this.props && this.props.hidden) ? <></> : <Alert color="danger">You do not have permission to access this resource.</Alert>)
                }
        </>
        )
    }
};

export default PermissionWrapper;